<template>
  <el-header>
    <el-row class="top-main">
      <el-col class="top-left"
              :span="12">
        <el-image style="width: 30px; height: 30px; vertical-align: middle;"
                  :src="imgDownUrl + logoSrc"
                  fit="fill"></el-image>
        <span class="ml-10 hidden-xs-only">{{systemTitle}}</span>
      </el-col>
      <el-col class="top-right"
              :span="12">
        <!-- <theme-picker class="hidden-xs-only"
                      style="vertical-align: middle;"></theme-picker> -->
        <el-dropdown @command="handleCommand">
          <div class="el-dropdown-link">
            <el-avatar class="avatar"
                       :size="30"
                       :src="imgDownUrl + avatarSrc"></el-avatar>
            <span>{{ username }}</span>
            <!-- <el-badge class="username ml-10"
                      :max="99"
                      :value="200"></el-badge> -->
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="username"
                              command="goManage">{{
              username
            }}</el-dropdown-item>
            <el-dropdown-item divided
                              command="gologin">退出系统</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>
  </el-header>
</template>

<script>
// import logoImg from '@/assets/img/logo.png'
// import ThemePicker from '../common/ThemePicker'
import fetch from '@/common/api'
export default {
  // components: { ThemePicker },
  data() {
    return {
      imgDownUrl: fetch.downImgUrl,
      logoSrc: '',
      avatarSrc: '',
      systemTitle: '',
      username: localStorage.getItem('username')
    }
  },
  created() {
    this.systemTitle = localStorage.getItem('systemTitle')
    this.avatarSrc =
      localStorage.getItem('avatar') ||
      'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
    this.logoSrc = localStorage.getItem('logo')
  },
  methods: {
    handleCommand(command) {
      if (command === 'gologin') {
        localStorage.clear()
        this.$router.push({
          path: '/login'
        })
        // fetch.logout({}).then((data) => {
        //   data.procData(
        //     data.res,
        //     () => {
        //     },
        //     (err) => {
        //       this.$message.error(err)
        //     }
        //   )
        // })
      } else if (command === 'goManage') {
        this.$router.push({
          path: '/admin'
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.el-header {
  width: 100%;
  background: #1677ff;
  color: #fff;
  line-height: 60px;
  .top-left {
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 3px;
    line-height: 60px;
  }
  .top-right {
    text-align: right;
    .el-dropdown {
      cursor: default;
      height: 60px;
      line-height: 60px;
      color: #fefefe;
    }
    .avatar {
      float: left;
      margin: 14px 10px 0;
    }
  }
}
</style>
